import { useContext, useState } from 'react';
import ThreeDotsOptionsMenu from '../threeDotsOptionsMenu';
import { AppContext } from '../../context';

import './customOptionsMenu.scss';
import { InfoDialogBox } from 'components/infoDialogBox';

function CustomOptionsMenu({
	id,
	menuContent,
	subscriptionStatus  = 'active',
}) {
	const [toggleMenu, setToggleMenu] = useState(false);
	const [toggleDialog, setToggleDialog] = useState(false);
	const { clickOutsideMenuRef } = useContext(AppContext);

	return (
		<div className="CustomOptionsMenu">
			{subscriptionStatus === 'past_due'&& (
				<InfoDialogBox
					memberId={id}
					toggleDialog={toggleDialog}
					setToggleDialog={setToggleDialog}
					outsideClickRef={clickOutsideMenuRef}
				/>
			)}
			<ThreeDotsOptionsMenu
				toggleMenu={toggleMenu}
				setToggleMenu={setToggleMenu}
				outsideClickRef={clickOutsideMenuRef}
				menuContent={menuContent}
			/>
			<div data-id={id} />
		</div>
	);
}

export default CustomOptionsMenu;
